(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-banner"] && !Shopify.designMode) return;
  try {
    
  if (!window.__collectionBannerScrollBound) {
    window.__collectionBannerScrollBound = true;
    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-scroll-to]');
      if (!link) return;
      const target = document.querySelector(link.getAttribute('href'));
      if (target) {
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-carousel')) {
    class HeroCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-carousel-dot]'));
        this.prevBtn = this.querySelector('[data-carousel-prev]');
        this.nextBtn = this.querySelector('[data-carousel-next]');
        this.status = this.querySelector('[data-carousel-status]');
        this.activeIndex = 0;
        this.autoplayDelay = parseInt(this.dataset.autoplayInterval, 10) || 6000;
        this.autoplayEnabled = this.dataset.autoplay === 'true' && this.slides.length > 1;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (this.slides.length <= 1 || !this.track) return;

        this.prevBtn?.addEventListener('click', () => this.go(this.activeIndex - 1));
        this.nextBtn?.addEventListener('click', () => this.go(this.activeIndex + 1));
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));

        this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });

        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') this.go(this.activeIndex + 1);
          if (event.key === 'ArrowLeft') this.go(this.activeIndex - 1);
        });

        this.addEventListener('pointerenter', () => this.pauseAutoplay());
        this.addEventListener('pointerleave', () => this.resumeAutoplay());
        this.addEventListener('focusin', () => this.pauseAutoplay());
        this.addEventListener('focusout', () => this.resumeAutoplay());

        if (this.autoplayEnabled && !this.reducedMotion) this.startAutoplay();
      }

      go(index) {
        const count = this.slides.length;
        const next = (index + count) % count;
        this.track.scrollTo({ left: this.track.clientWidth * next, behavior: 'smooth' });
      }

      onScroll() {
        if (this.scrollRaf) cancelAnimationFrame(this.scrollRaf);
        this.scrollRaf = requestAnimationFrame(() => {
          const width = this.track.clientWidth || 1;
          const index = Math.round(this.track.scrollLeft / width);
          if (index !== this.activeIndex) this.setActive(index);
        });
      }

      setActive(index) {
        this.activeIndex = index;

        this.slides.forEach((slide, i) => {
          const isActive = i === index;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        this.dots.forEach((dot, i) => {
          const isActive = i === index;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        if (this.status) {
          this.status.textContent = `Slide ${index + 1} of ${this.slides.length}`;
        }
      }

      startAutoplay() {
        this.stopAutoplay();
        this.autoplayTimer = setInterval(() => this.go(this.activeIndex + 1), this.autoplayDelay);
      }

      stopAutoplay() {
        if (this.autoplayTimer) clearInterval(this.autoplayTimer);
      }

      pauseAutoplay() {
        this.stopAutoplay();
      }

      resumeAutoplay() {
        if (this.autoplayEnabled && !this.reducedMotion) this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
      }
    }

    customElements.define('hero-carousel', HeroCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
